import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { treeActions } from '../../redux/slices/treeSlice';

const HideMappingButton = ({ side = 'source' }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const isMappingMode = useSelector(state => state.treeData.mappingStates.isMappingMode);
  const hiddenMappingLines = useSelector(state => state.treeData.mappingStates.hiddenMappingLines);
  
  // Only show the button when in mapping mode
  if (!isMappingMode) {
    return null;
  }
  
  // Check if this side's mapping lines are hidden
  const isHidden = hiddenMappingLines?.[side] || false;
  
  const handleToggleMappingLines = () => {
    if (side === 'source') {
      if (isHidden) {
        dispatch(treeActions.showSourceMappingLines());
      } else {
        dispatch(treeActions.hideSourceMappingLines());
      }
    } else {
      if (isHidden) {
        dispatch(treeActions.showTargetMappingLines());
      } else {
        dispatch(treeActions.hideTargetMappingLines());
      }
    }
  };
  
  const getTooltipText = () => {
    const sideText = side === 'source' ? 'Source' : 'Target';
    return isHidden 
      ? t('SHOW_MAPPING_LINES') 
      : t('HIDE_MAPPING_LINES');
  };
  
  return (
    <Tooltip title={getTooltipText()}>
      <IconButton 
        onClick={handleToggleMappingLines} 
        size="small" 
        style={{ margin: '0' }}
      >
        {isHidden ? (
          <VisibilityOutlined fontSize="small" />
        ) : (
          <VisibilityOffOutlined fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default HideMappingButton;